<template>
  <div v-if="customFields.length">
    <slot name="title" />
    <custom-field-renderer
      v-for="field in customFields"
      :key="field.key"
      :field="field"
      v-model="fieldValues[field.key]"
      :loading="keyLoading === field.key"
      @input="handleFieldChange($event, field)"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import CustomFieldRenderer from "@/components/root/forms/customFields/CustomFieldRenderer.vue";

export default {
  name: "CustomFieldsLead",
  components: {
    CustomFieldRenderer
  },
  props: {
    lead: {
      type: Object,
      required: true
    },
    keyLoading: String
  },
  data() {
    return {
      fieldValues: {}
    };
  },
  watch: {
    lead: {
      handler() {
        this.initFieldValues();
      }
    }
  },
  computed: {
    ...mapState({
      customFields: state =>
        state.realEstateGroup.realEstateGroup?.custom_fields || []
    })
  },
  methods: {
    initFieldValues() {
      this.fieldValues = this.customFields.reduce((acc, field) => {
        acc[field.key] = this.getFieldValue(field);
        return acc;
      }, {});
    },
    getFieldValue(field) {
      return (
        this.lead.custom_fields?.[field.key] ?? this.getDefaultValue(field)
      );
    },
    getDefaultValue(field) {
      if (!field) return null;

      switch (field.type) {
        case "string":
          return "";
        case "number":
          return null;
        case "boolean":
          return false;
        case "array":
          return [];
        default:
          return null;
      }
    },
    async handleFieldChange(value, field) {
      try {
        this.$emit("update:field", {
          field,
          value
        });
      } catch (error) {
        this.$snotify.error("Error al actualizar el campo");
      }
    }
  }
};
</script>
